export const MobileWidth = 414;
export const TabletWidth = 768;